var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "45",
        height: "45",
        viewBox: "0 0 38 38",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        staticClass: "step-svg-path",
        attrs: {
          d:
            "M8.86647 3.7998C8.53054 3.79984 8.20838 3.9333 7.97084 4.17084C7.7333 4.40838 7.59984 4.73054 7.5998 5.06647V26.5998H5.06647C4.73054 26.5998 4.40838 26.7333 4.17084 26.9708C3.9333 27.2084 3.79984 27.5305 3.7998 27.8665C3.7998 31.3492 6.65042 34.1998 10.1331 34.1998H26.5998C26.642 34.1994 26.6841 34.1969 26.726 34.1924C30.1506 34.1239 32.9331 31.3066 32.9331 27.8665V5.06647C32.9331 4.73054 32.7996 4.40838 32.5621 4.17084C32.3246 3.9333 32.0024 3.79984 31.6665 3.7998H8.86647ZM10.1331 6.33314H30.3998V27.8665C30.3998 29.9799 28.7132 31.6665 26.5998 31.6665C24.4864 31.6665 22.7998 29.9799 22.7998 27.8665C22.7998 27.5305 22.6663 27.2084 22.4288 26.9708C22.1912 26.7333 21.8691 26.5998 21.5331 26.5998H10.1331V6.33314ZM13.9331 10.1331V12.6665H16.4665V10.1331H13.9331ZM18.9998 10.1331V12.6665H26.5998V10.1331H18.9998ZM13.9331 15.1998V17.7331H16.4665V15.1998H13.9331ZM18.9998 15.1998V17.7331H26.5998V15.1998H18.9998ZM13.9331 20.2665V22.7998H16.4665V20.2665H13.9331ZM18.9998 20.2665V22.7998H26.5998V20.2665H18.9998Z",
          fill: "currentColor"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }